export const PHONE_NOTIFICATION_PREFERENCES = 'phone-notification-preferences'
export const PATIENT_HOME = {
  RESERVATION_CARD: 'patient-home-reservation-card',
  RESERVATION_SPECIALTY_SELECTOR: 'patient-home-reservation-specialty-selector',
}